import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout__wrapper" }
const _hoisted_2 = { class: "layout__wrapper" }

import { onBeforeUnmount } from 'vue'

import type { DocView } from '@/models/doc'
import Layout from '@/app/components/Layout.vue'
import LoadingSpinner from '@/components/ui/LoadingSpinner.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DocSummaryPage',
  props: {
    doc: {},
    isLoadingDoc: { type: Boolean },
    isErrorLoadingDoc: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

onBeforeUnmount(() => {
  if (props.doc && props.doc.readingProgress) {
    props.doc.readingProgress.destroy()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_LoadingError = _resolveComponent("LoadingError")!

  return (_openBlock(), _createElementBlock("div", null, [
    (__props.isLoadingDoc)
      ? (_openBlock(), _createBlock(Layout, {
          key: 0,
          "show-upgrade-prompt-modal": false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(LoadingSpinner)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.doc)
      ? (_openBlock(), _createBlock(_component_router_view, {
          key: 1,
          doc: __props.doc
        }, null, 8, ["doc"]))
      : _createCommentVNode("", true),
    (!__props.doc && __props.isErrorLoadingDoc)
      ? (_openBlock(), _createBlock(Layout, {
          key: 2,
          "show-upgrade-prompt-modal": false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_LoadingError)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})